export const UNASSIGNED_ROOM_LABEL = $localize`:@@UNASSIGNED:Unassigned`;

export function resolveRoomDisplayName(
  name?: string | null,
  isMasterRoom?: boolean,
  roomId?: string | null
): string {
  const trimmed = name?.trim();
  if (trimmed) return trimmed;
  if (!roomId) return '';
  if (isMasterRoom) return UNASSIGNED_ROOM_LABEL;
  return '';
}
